import { createLocalStorage } from '@collector/shared-ui'

const SportsApiRefreshToken = createLocalStorage('SportsAPI_refresh_token')

export { SportsApiRefreshToken }
